import ContactDetailsComponent from '../components/ContactDetailsComponent';
import { planSent, setRequestResellerAssistance } from '../actions/plan.js';
import { updateContactDetails } from '../actions/index'
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => ({
    nextPage: ownProps.nextPage,
    contactDetails: state.contactDetails,
    showResellerAssistanceRequest: state.clientConfiguration.showResellerAssistanceRequest,
    resellerAssistanceRequested: state.plan.requestResellerAssistance,
    planType: state.plan.planType
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    submitContactForm: (values) => {
        dispatch(updateContactDetails(values));
        dispatch(planSent());
        ownProps.nextPage();
    },
    resellerAssistanceChanged:(value) => {
        dispatch(setRequestResellerAssistance(value));
    }
});

const ContactDetailsPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactDetailsComponent);

export default ContactDetailsPageContainer;

